import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormDataType } from 'contexts/FormProvider';
import { phoneNumberSchema } from 'utils/utils';
import { createFormErrorMessage } from 'utils/helperMethods';

type Phone = {
  mPhoneNumber: string;
  hPhoneNumber: string;
  oPhoneNumber: string;
  preferredMethod: string;
  haveOneValidNumber: string;
};

const useValidNumber = (phone: Phone, form: UseFormReturn<FormDataType>) => {
  const { mPhoneNumber, hPhoneNumber, oPhoneNumber, preferredMethod, haveOneValidNumber } = phone;
  const { setValue, setError, clearErrors: clearError } = form;

  useEffect(() => {
    const haveValidNumber = [mPhoneNumber, hPhoneNumber, oPhoneNumber].some((phoneNumber) =>
      phoneNumberSchema(false).isValidSync(phoneNumber)
    );

    setValue(haveOneValidNumber as keyof FormDataType, haveValidNumber);

    if (preferredMethod === 'phone' && !haveValidNumber) {
      setError(
        haveOneValidNumber as keyof FormDataType,
        createFormErrorMessage('required', 'must have one valid number')
      );
    } else clearError(haveOneValidNumber as keyof FormDataType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hPhoneNumber, mPhoneNumber, oPhoneNumber, preferredMethod]);
};

export default useValidNumber;
